import React, { useState } from 'react';
import { FadeUp } from './ui/FadeUp';
import { CheckCircle2Icon } from 'lucide-react';
export function IntakeFormSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      const response = await fetch('https://formsubmit.co/ajax/krystina@joinsparkhr.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });
      if (response.ok) {
        setIsSuccess(true);
        form.reset();
      } else {
        throw new Error('Form submission failed');
      }
    } catch (err) {
      setError('Something went wrong. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="start-here" className="py-28 bg-white" data-id="element-230">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-231">
        <div className="max-w-3xl mx-auto" data-id="element-232">
          <FadeUp className="text-center mb-12" data-id="element-233">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-234">
              HR is getting messy — let's fix it.
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-235">
              Not sure what you actually need yet? Tell us what's going on —
              we'll point you in the right direction.
            </p>
          </FadeUp>

          <FadeUp delay={0.1} data-id="element-236">
            <div className="bg-white rounded-2xl border border-[#eee] shadow-[0_10px_40px_rgba(0,0,0,0.04)] p-8 md:p-12" data-id="element-237">
              {isSuccess ? <div className="text-center py-12" data-id="element-238">
                  <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-239">
                    <CheckCircle2Icon className="w-8 h-8 text-green-500" data-id="element-240" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-241">
                    Thanks! We'll be in touch shortly.
                  </h3>
                  <p className="text-gray-600" data-id="element-242">
                    We've received your information and will get back to you
                    with a recommendation.
                  </p>
                  <button onClick={() => setIsSuccess(false)} className="mt-8 text-purple-600 font-medium hover:text-purple-700 transition-colors" data-id="element-243">
                    Submit another request
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-244">
                  <input type="hidden" name="_subject" value="New SparkHR Intake Form Submission" data-id="element-245" />
                  <input type="hidden" name="_captcha" value="false" data-id="element-246" />
                  <input type="hidden" name="_template" value="table" data-id="element-247" />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-248">
                    <div className="space-y-2" data-id="element-249">
                      <label htmlFor="companyName" className="block text-sm font-semibold text-gray-900" data-id="element-250">
                        Company Name
                      </label>
                      <input type="text" id="companyName" name="Company Name" required className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none" placeholder="Acme Corp" data-id="element-251" />
                    </div>

                    <div className="space-y-2" data-id="element-252">
                      <label htmlFor="email" className="block text-sm font-semibold text-gray-900" data-id="element-253">
                        Work Email
                      </label>
                      <input type="email" id="email" name="Email" required className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none" placeholder="you@company.com" data-id="element-254" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-255">
                    <div className="space-y-2" data-id="element-256">
                      <label htmlFor="teamSize" className="block text-sm font-semibold text-gray-900" data-id="element-257">
                        Team Size
                      </label>
                      <select id="teamSize" name="Team Size" required className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none appearance-none" data-id="element-258">
                        <option value="" disabled selected data-id="element-259">
                          Select team size...
                        </option>
                        <option value="1-10" data-id="element-260">1-10 employees</option>
                        <option value="11-25" data-id="element-261">11-25 employees</option>
                        <option value="26-50" data-id="element-262">26-50 employees</option>
                        <option value="51-100" data-id="element-263">51-100 employees</option>
                        <option value="100+" data-id="element-264">100+ employees</option>
                      </select>
                    </div>

                    <div className="space-y-2" data-id="element-265">
                      <label htmlFor="timeline" className="block text-sm font-semibold text-gray-900" data-id="element-266">
                        Timeline
                      </label>
                      <select id="timeline" name="Timeline" required className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none appearance-none" data-id="element-267">
                        <option value="" disabled selected data-id="element-268">
                          When do you need help?
                        </option>
                        <option value="ASAP" data-id="element-269">ASAP</option>
                        <option value="Next 30 days" data-id="element-270">Next 30 days</option>
                        <option value="Just exploring" data-id="element-271">Just exploring</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-272">
                    <label htmlFor="supportType" className="block text-sm font-semibold text-gray-900" data-id="element-273">
                      What kind of support do you need?
                    </label>
                    <select id="supportType" name="Support Type" required className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none appearance-none" data-id="element-274">
                      <option value="" disabled selected data-id="element-275">
                        Select support type...
                      </option>
                      <option value="Day-to-day HR support" data-id="element-276">
                        Day-to-day HR support
                      </option>
                      <option value="HR systems setup" data-id="element-277">HR systems setup</option>
                      <option value="Full HR + admin operations" data-id="element-278">
                        Full HR + admin operations
                      </option>
                      <option value="Not sure yet" data-id="element-279">Not sure yet</option>
                    </select>
                  </div>

                  <div className="space-y-2" data-id="element-280">
                    <label htmlFor="message" className="block text-sm font-semibold text-gray-900" data-id="element-281">
                      What's going on?{' '}
                      <span className="text-gray-400 font-normal" data-id="element-282">
                        (Optional)
                      </span>
                    </label>
                    <textarea id="message" name="Message" rows={3} className="w-full px-4 py-3 rounded-xl border border-[#eee] bg-gray-50/50 focus:bg-white focus:border-purple-300 focus:ring-2 focus:ring-purple-100 transition-all outline-none resize-none" placeholder="Briefly describe your current HR challenges..." data-id="element-283"></textarea>
                  </div>

                  {error && <div className="p-4 bg-red-50 text-red-600 rounded-xl text-sm" data-id="element-284">
                      {error}
                    </div>}

                  <button type="submit" disabled={isSubmitting} className="w-full py-4 px-8 text-base font-bold text-white bg-gradient-primary rounded-xl hover:shadow-lg hover:opacity-90 transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center" data-id="element-285">
                    {isSubmitting ? <span className="flex items-center gap-2" data-id="element-286">
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-287">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-288"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-289"></path>
                        </svg>
                        Sending...
                      </span> : 'Get My HR Plan'}
                  </button>
                  <p className="text-center text-sm text-gray-400 mt-4" data-id="element-290">
                    No commitment — I'll review this personally and point you in
                    the right direction.
                  </p>
                </form>}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>;
}